<template>
    <div class="body-panel sku">

        <div class="body-panel-control separator">
            <div class="body-panel-control-separator" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
                <div class="control-block-left" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
                    <div class="flex">
                        <project-select :user="info.User" @onChange="onProjectChange"></project-select>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex" data-toggle="buttons">
                        <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                               class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange()" />
                        <input type="file" id="dropFiles2" ref="dropFiles2" name="dropFiles2"
                               class="file-upload-zone-btn" accept=".xlsx" @change="onFileSkuLinkChange()" />


                        <button type="button" class="btn"
                                v-context-menu="'settingsList'"
                                v-if="hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators'">
                            Настройки
                        </button>
                        <button type="button" class="btn" v-context-menu="'exportList'" >
                            Экспорт и импорт
                        </button>
                    </div>

                    <div id="settingsList" class="dropdown-menu dropdown-list">
                        <a class="dropdown-menu-item" @click="onAddSku">
                            <span>Добавить SKU</span>
                        </a>
                        <a class="dropdown-menu-item" @click="onAddFolder">
                            <span>Добавить папку</span>
                        </a>
                        <a class="dropdown-menu-item" @click="onShowModal('ppGroups')">
                            <span>Управление группами</span>
                        </a>
                        <a class="dropdown-menu-item" @click="onShowModal('ppSkuFieldSettings')">
                            <span>Настройка полей SKU</span>
                        </a>
                    </div>

                    <div id="exportList" class="dropdown-menu dropdown-list">
                        <a class="dropdown-menu-item" href="javascript:document.getElementById('dropFiles2').click()"
                           v-if="hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators'">
                            <span>Импорт или обновление связей</span>
                        </a>
                        <a class="dropdown-menu-item" @click="onSkuLinkExport()"
                           v-if="hasClaims(info.User.DynamicRole, claimEnums.skuLinkExport) || info.User.MainRole === 'administrators'">
                            <span>Экспорт связей</span>
                        </a>
                        <a class="dropdown-menu-item" href="javascript:document.getElementById('dropFiles').click()"
                           v-if="hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators'">
                            <span>Импорт или обновление SKU</span>
                        </a>
                        <a class="dropdown-menu-item" @click="onExport()">
                            <span>Экспорт SKU</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="body-panel-control-separator flex">
                <p class="btn-back margin-right-10" v-if="$route.query.folderId">
                    <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                </p>
                <div class="input-group">
                    <input type="text" class="input-text" v-model="search" placeholder="Поиск по названию и описанию" @input="onSearchChange($event)" />
                    <button type="button" class="btn btn-img input-group-addon" title="Очистить" @click="onSearchClear" v-if="search">
                        <i class="fa fa-close"></i>
                    </button>
                </div>

                <div class="switch margin-left-10" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators')">
                    <input type="checkbox" id="s5" checked="checked" v-model="active" @change="reload" />
                    <label class="slider-v3" for="s5"></label>
                </div>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page panel-block-news no-padding-right">
            <div class="result-import margin-bottom-20" v-if="importResult != null">
                Успешно импортировано: {{ importResult.SuccessfullyExported }} {{ get_text_ending(importResult.SuccessfullyExported, ['строка', 'строки', 'строк']) }}<br><br>
                <template v-if="importResult.Errors.length">
                    Ошибки:
                    <br>
                    <ul>
                        <li v-for="error of importResult.Errors">
                            {{error}}
                        </li>
                    </ul>
                </template>
                <button class="btn" @click="importResult = null;">Закрыть</button>
            </div>
            <div class="body-panel-content-center">
                <template v-for="(item, i) of sku" v-if="skuSettings != null">
                    <h2 v-if="item.Group && item.Group.Name != null" class="group-header">{{ item.Group.Name }}</h2>
                    <div class="panel-block panel-block-new" @click="onItemClick(item)">
                        <div class="panel-block-img-base">
                            <div class="panel-block-img">
                                <img :src="item.Image" alt="" :style="getImageStyleFormatted(item.ImageStyle)" v-if="!item.IsFolder" />
                                <img :src="item.Image" alt="" :style="getImageStyleFormatted(item.ImageStyle)" v-if="item.IsFolder" />
                            </div>
                        </div>
                        <div class="panel-block-info">
                            <template v-if="item.IsFolder">
                                <p class="panel-block-header margin-bottom-10">{{ item.Name }}</p>
                                <p class="panel-body-desc" v-html="item.DescriptionFormatted"></p>
                            </template>
                            <template v-if="!item.IsFolder">
                                <p class="panel-block-header margin-bottom-10" v-if="skuSettings.Name.ShowInList">{{ item.Name }}</p>

                                <template v-for="s of skuSettingsOrdered" v-if="s.FieldName !== 'Name' && s.ShowInList">
                                    <p class="panel-body-desc" v-if="s.FieldName === 'Description'" v-html="item.DescriptionFormatted"></p>
                                    <p :class="['input-text-lbl', s.FieldName]" v-else-if="item[s.FieldName]">
                                        <span>{{s.Title}}:  </span>{{ item[s.FieldName] }}<template v-if="s.FieldName === 'RRC'"> руб.</template>
                                    </p>
                                </template>

                                <p class="input-text-lbl" v-if="item.AmountForUser">
                                    <span>Баллы за отчёт: {{formatAmountForUser(item.AmountForUser)}}</span>
                                </p>
                            </template>
                        </div>
                        <div class="panel-body-actions panel-body-actions-false"></div>
                        <div class="panel-body-actions panel-body-actions-footer" v-if="!item.IsFolder">
                            <button class="btn" @click.stop="goToSku(item.Id)">Подробнее</button>
                            <button class="btn btn-img" @click.stop="goToSkuEdit(item.Id)" v-if="item.Id > 0 && info.User && (hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators')">
                                <img src="../../img/pencil-edit-button.png" alt="" />
                            </button>
                        </div>
                        <div class="panel-body-actions panel-body-actions-footer" v-if="item.IsFolder">
                            <button class="btn" @click.stop="goToFolder(item.Id)">Подробнее</button>
                            <button class="btn btn-img" @click.stop="goToFolderEdit(item.Id)" v-if="item.Id > 0 && info.User && (hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators')">
                                <img src="../../img/pencil-edit-button.png" alt="" />
                            </button>
                        </div>
                    </div>
                </template>

                <template v-if="emptyResults">
                    <h2>Ничего не найдено...</h2>
                </template>
            </div>
        </div>

        <popup-window ref="ppSkuFieldSettings" :title="'Настройка отображения полей SKU'" :width="800" :modal="true">
            <div>
                <p class="caption-help">Настройка отображения и использования полей справочника в данном проекте</p>
                <!--{{skuSettings}}-->
                <table class="table-view" id="tSkuFieldSett">
                    <thead class="head-show">
                        <tr class="heading">
                            <th>Название поля</th>
                            <th>Список</th>
                            <th>Детали</th>
                            <th style="width: 100px;" v-if="customSettingsFieldsCount > 0"></th>
                        </tr>
                    </thead>
                    <Container v-if="skuSettingsOrdered != null" :lock-axis="'y'" tag="tbody" @drop="onSkuSettingsDrop" @drag-start="onDragStart">
                        <Draggable :key="s" tag="tr" v-for="(skuSettingsItem, s) of skuSettingsOrdered" :lock-axis="'x'">
                            <td>
                                <template v-if="skuSettingsItem.Edited">
                                    <input type="text" class="input-text"
                                           :name="'settings_' + skuSettingsItem.FieldName"
                                           v-model="skuSettingsItem.Title" />
                                </template>
                                <template v-else>
                                    {{ skuSettingsItem.Title }}
                                </template>
                            </td>
                            <td class="bit">
                                <input :id="'list' + s" :name="'list' + s" v-model="skuSettingsItem.ShowInList" value="true" type="checkbox" class="input-checkbox" :disabled="checkDisabledSettingsItem(skuSettingsItem.FieldName)" />
                                <label :for="'list' + s" class="input-checkbox-lbl no-text"></label>
                            </td>
                            <td class="bit">
                                <input :id="'det' + s" :name="'det' + s" v-model="skuSettingsItem.ShowInDetails" value="true" type="checkbox" class="input-checkbox" :disabled="skuSettingsItem.FieldName === 'Name'" />
                                <label :for="'det' + s" class="input-checkbox-lbl no-text"></label>
                            </td>
                            <td v-if="customSettingsFieldsCount > 0">
                                <template v-if="skuSettingsItem.Edited">
                                    <button type="button" class="btn" @click.stop="onSettingsOkBtn(skuSettingsItem)">Ok</button>
                                </template>
                                <template v-if="skuSettingsItem.FieldName.startsWith('CustomField') && !skuSettingsItem.Edited">
                                    <div class="btns flex">
                                        <button type="button" class="btn btn-img" @click.stop="onSettingsEditBtn(skuSettingsItem)"><img src="../../img/pencil-edit-button.png" alt="" /></button>
                                        <button type="button" class="btn btn-img" @click.stop="onSettingsRemoveBtn(skuSettingsItem)"><img src="../../img/icon-del.png" alt="" /></button>
                                    </div>
                                </template>
                            </td>
                        </Draggable>
                    </Container>
                </table>
            </div>
                <div class="flex btns">
                    <button class="btn margin-top-20" @click.stop="onAddNewSettings" v-if="customSettingsFieldsCount < 50">Добавить</button>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary" @click="onSaveSettings">Сохранить</button>
                    <button type="button" class="btn" @click="onCloseSettings">Отмена</button>
                </div>
            
        </popup-window>

        <popup-window ref="ppGroups" :title="'Управление группами SKU'" :width="800">
            <Container @drop="onDrop" :lock-axis="'y'">
                <Draggable v-for="(group, i) of groupsOrdered">
                    <div class="draggable-item" @click="onGroupSelect(group)">
                        <template v-if="group.Edited">
                            <div class="flex" style="">
                                <input type="text" class="input-text"
                                       v-model="group.Name" />
                                <button class="btn btn-primary" @click.stop="onSaveGroup(group)">
                                    Ok
                                </button>
                                <button class="btn btn-default" @click.stop="onGroupEditCancel(group)">
                                    Отмена
                                </button>
                            </div>
                        </template>
                        <template v-if="!group.Edited">
                            {{ group.Name }}
                            <div class="btns flex" style="float:right;margin-top:-6px">
                                <button class="btn btn-default btn-img" @click.stop="onGroupEdit(group)">
                                    <img src="../../img/pencil-edit-button.png" alt="" />
                                </button>
                                <button class="btn btn-default btn-img" @click.stop="onRemoveGroup(group, i)">
                                    <img src="../../img/icon-del.png" alt="" />
                                </button>
                            </div>
                        </template>
                    </div>
                </Draggable>
            </Container>
            <div class="flex btns">
                <button class="btn margin-top-10" @click.stop="onAddNewGroup">Добавить</button>
                <button class="btn margin-top-10" @click.stop="saveGroups" v-if="groupsChanged">Сохранить</button>
            </div>
        </popup-window>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import _ from 'lodash'
    import config from '../config'
    import { Container, Draggable } from 'vue-smooth-dnd'

    let backendApi = new BackendApi();
    let cacheKey = 'skuState';

    export default {
        name: "sku",

        props: ['info'],

        mixins: [projectMixin], // projectId

        components: { Container, Draggable },

        data() {
            return {
                sku: [],
                skuSettings: null,
                loading: false,
                canBeLoaded: true,
                page: 1,
                rowsPerPage: 20,
                projectId: null,
                search: null,
                active: true,
                importResult: null,
                groups: [],
                groupsOrigin: null,
                lastGroupId: null,
                scrollTop: null,
                firstLoad: true,
                emptyResults: false
            }
        },

        computed: {
            groupsOrdered(){
                return _.orderBy(this.groups, 'GroupOrder');
            },

            skuSettingsOrdered(){
                if(this.skuSettings == null){
                    return null;
                }

                return _.orderBy(Object.values(this.skuSettings), 'SettingsOrder');
            },

            groupsChanged(){
                return !_.some(this.groups, {Edited: true}) && JSON.stringify(this.groups) !== JSON.stringify(this.groupsOrigin);
            },

            customSettingsFieldsCount(){
                if(this.skuSettings == null){
                    return false;
                }

                return Object.values(this.skuSettings).filter(x => x.FieldName.startsWith('CustomField')).length;
            }
        },

        watch: {
            '$route.query.folderId'(to, from) {
                this.reload();
            }
        },

        methods: {
            back() {
                this.$router.back();
            },

            formatAmountForUser(amountForUser) {
                return amountForUser.join(', ');
            },

            checkDisabledSettingsItem(fieldName) {
                return ['Name', 'Code', 'SkuOrder', 'ExternalCode', 'UnitBarCode', 'BoxBarCode', 'Volume', 'Weight', 'Amount'].indexOf(fieldName) > -1;
            },

            getImageStyleFormatted(imageStyle) {
                if (!imageStyle) {
                    return null;
                }

                let settings = {
                    left: imageStyle.left + '%',
                    top: imageStyle.top + '%',
                    transform: 'translateY(' + imageStyle.translateY + '%) translateX(' +
                    imageStyle.translateX + '%)'
                };
                if (imageStyle.resizeType === 1 && parseInt(imageStyle.size)) {
                    settings.height = imageStyle.size + '%';
                }
                if (imageStyle.resizeType === 2 && parseInt(imageStyle.size)) {
                    settings.width = imageStyle.size + '%';
                }

                return settings;
            },

            onCloseSettings() {
                this.$refs.ppSkuFieldSettings.close();
            },

            onFileChange() {
                let vm = this;

                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }

                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if (tokenInfo != null) {
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/sku/import?projectId=' + vm.projectId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка импорта');
                                }
                                else {
                                    //console.info('resp', resp)
                                    vm.importResult = resp.result;
                                    UI.toastr.success('Успешно импортировано');
                                    vm.reload()
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            onFileSkuLinkChange(){
                let vm = this;

                let files = document.getElementById('dropFiles2').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }

                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if (tokenInfo != null) {
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/sku/importLink?projectId=' + vm.projectId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка импорта');
                                }
                                else {
                                    vm.importResult = resp.result;
                                    UI.toastr.success('Успешно импортировано');
                                    vm.reload()
                                }
                                UI.unblockUI('#app');
                                document.getElementById('dropFiles2').value = '';
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error(xhr.responseText);
                                UI.unblockUI('#app');
                                document.getElementById('dropFiles2').value = '';
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            onSaveSettings() {
                let vm = this;
                let fields = Object.values(vm.skuSettings).filter(x => x.Edited);
                if (fields.length > 0) {
                    for (let i = 0; i < fields.length; i++) {
                        let qnt = Object.values(vm.skuSettings).filter(x => !x.Edited && x.Title === fields[i].Title).length;
                        if (qnt > 0) {
                            UI.toastr.error('Укажите другое название поля. Поле [' + fields[i].Title + '] уже используется');
                            return;
                        }
                    }
                }

                this.callApiWrapper(backendApi.skuSettingsSave(vm.projectId, vm.skuSettings))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время сохранения настроек sku');
                        }
                        else {
                            UI.toastr.success('Успешно сохранено');
                            vm.$refs.ppSkuFieldSettings.close();
                        }
                    })

            },

            reload() {
                let vm = this;

                this.clearFilterState();
                this.page = 1;
                this.loading = false;
                this.canBeLoaded = true;
                this.sku = [];
                this.lastGroupId = null;
                this.firstLoad = true;
                this.emptyResults = false;

                Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
                    if (!vm.loading && vm.canBeLoaded) {
                        vm.loadNext();
                    }
                });
            },

            onSearchChange: _.debounce(function ($event) {
                //this.search = $event.target.value;
                this.reload();

            }, 500),

            onSearchClear(){
                this.search=null;
                this.reload();
            },

            loadNext() {
                let vm = this;
                this.loading = true;
                let folderId = vm.$route.query.folderId;
                UI.blockUI('.sku', 'Загрузка...');
                let skip = (vm.page - 1) * vm.rowsPerPage;
                let take = vm.rowsPerPage;
                if (vm.firstLoad && vm.page > 1) {
                    skip = 0;
                    take = vm.page * vm.rowsPerPage;
                }

                this.callApiWrapper(backendApi.skuList(skip, take, vm.projectId, vm.search, vm.active, folderId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрзуки SKU');
                        }
                        else {
                            if (resp.data && resp.data.length) {

                                for (let i = 0; i < resp.data.length; i++) {
                                    let item = resp.data[i];

                                    if (item.Description) {
                                        item.DescriptionFormatted = item.Description.replace(/\n/g, '<br>');
                                    }
                                    if (item.ImageStyle) {
                                        item.ImageStyle = JSON.parse(item.ImageStyle);
                                    }
                                    if (!item.IsFolder) {
                                        if (item.Group) {
                                            if (item.Group.Id !== vm.lastGroupId) {
                                                vm.lastGroupId = item.Group.Id;
                                                item.Group.Name = vm.groups.find(x => x.Id === item.Group.Id).Name;
                                            }
                                            else {
                                                item.Group.Name = null;
                                            }
                                        }
                                        else {
                                            if (vm.lastGroupId == null && vm.groups.length) {
                                                vm.lastGroupId = 0;
                                                item.Group = {Id: 0, Name: 'Группа не выбрана'};
                                            }
                                        }
                                    }
                                }

                                vm.sku.push(...resp.data);

                                if (vm.firstLoad) {
                                    vm.firstLoad = false;
                                    if (vm.scrollTop) {
                                        $('.body-panel-content').animate({scrollTop: vm.scrollTop}, 500);
                                    }
                                }
                            }
                            else {
                                vm.canBeLoaded = false;
                                if (vm.search && !vm.sku.length) {
                                    vm.emptyResults = true;
                                }
                            }
                        }
                        UI.unblockUI('.sku');
                        vm.loading = false;
                    })
                    .catch(function (err) {
                        console.info('err', err)
                        UI.toastr.error('Ошибка во время загрузки');
                    })
            },

            loadSettings() {
                let vm = this;
                return this.callApiWrapper(backendApi.skuSettings(vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки настроек sku');
                        }
                        else {
                            if (resp.data) {

                                let dict = {};
                                for(let s of resp.data){
                                    if(!dict[s.FieldName]){
                                        dict[s.FieldName] = s;
                                    }
                                }

                                vm.skuSettings = dict;
                            }
                        }
                    })
            },

            loadGroups() {
                let vm = this;

                return this.callApiWrapper(backendApi.skuGroupList(vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки групп sku');
                        }
                        else {
                            if (resp.data) {
                                resp.data.forEach((r) => {
                                    r.Edited = false;
                                    r.Selected = false;
                                    r.OriginName = r.Name;
                                });

                                vm.groups = resp.data;
                                vm.groupsOrigin = JSON.parse(JSON.stringify(resp.data));
                            }
                        }
                    })
            },

            goToSku(id) {
                this.saveFilterState();
                this.$router.push('/sku/' + id);
            },

            goToFolder(id) {
                this.saveFilterState();
                this.$router.push('/sku/?folderId=' + id);
            },

            onItemClick(item){
                if(item.IsFolder){
                    this.goToFolder(item.Id);
                }
                else{
                    this.goToSku(item.Id);
                }
            },

            goToSkuEdit(id) {
                this.saveFilterState();
                this.$router.push('/sku/edit/' + id);
            },

            goToFolderEdit(id) {
                this.saveFilterState();
                this.$router.push('/sku/folder/edit/' + id);
            },

            onAddSku() {
                this.$router.push('/sku/edit/0');
            },

            onAddFolder() {
                let folderId = this.$route.query.folderId;
                this.$router.push('/sku/folder/edit/0' + (folderId ? '?folderId=' + folderId : ''));
            },

            onProjectChange(item) {
                this.projectId = item.Id;
                if(this.$route.query.folderId){
                    this.$router.replace({query: {}});
                }
                this.reload();
                this.$emit('user-updated');
            },

            onShowModal(modal) {
                this.$nextTick(() => {
                    this.$refs[modal].show();
                });
            },

            onExport() {
                let vm = this;
                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.skuExport(vm.projectId, (vm.search ? vm.search : ''), vm.active))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'SKU.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onSkuLinkExport(){
                let vm = this;
                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.skuExportLink(vm.projectId, (vm.search ? vm.search : ''), vm.active))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Связи SKU.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onAddNewGroup() {
                let vm = this;
                let maxOrder = 1;
                this.groups.forEach((r) => {
                    if (r.GroupOrder > maxOrder) {
                        maxOrder = r.GroupOrder;
                    }
                    r.Edited = false;
                });

                this.groups.push({
                    Id: 0,
                    Name: 'Новая группа',
                    OriginName: 'Новая группа',
                    ProjectId: vm.projectId,
                    GroupOrder: ++maxOrder,
                    Edited: true,
                    Selected: true
                });
            },

            onDragStart () {
                let vm=this;
                vm.$nextTick(()=>{
                    let marginLeft = -($(document).width()-$('.popup-content').width())/2;
                    let marginTop = -($(document).height()-$('.popup-content').height())/2;
                    $('.smooth-dnd-ghost').css({'margin-left': marginLeft+'px', 'margin-top': marginTop+'px'});
                });

            },

            onDrop(dropResult) {
                let vm = this;

                if (dropResult.removedIndex === dropResult.addedIndex) {
                    return;
                }

                let rolesTemp = _.orderBy(vm.groups, 'GroupOrder');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                rolesTemp.forEach((role) => {
                    role.GroupOrder = order++;
                });

                vm.groups = rolesTemp;

                //this.saveRoles(this.groups);
            },

            onGroupEdit(role) {
                this.groups.forEach((r) => {
                    r.Edited = false;
                });
                role.Edited = true;
            },

            onGroupSelect(role) {
                this.groups.forEach((r) => {
                    r.Selected = false;
                });
                role.Selected = true;
            },

            onRemoveGroup(role) {
                let vm = this;
                let indexRemove;
                for (let i = 0; i < vm.groups.length; i++) {
                    if (vm.groups[i].GroupOrder === role.GroupOrder) {
                        indexRemove = i;
                        break;
                    }
                }
                vm.groups.splice(indexRemove, 1);
            },

            onSaveGroup(group) {
                if (group.Name) {
                    group.Edited = false;
                    group.OriginName = group.Name;
                }
            },

            saveGroups() {
                let vm = this;

                UI.blockUI('.portlet', 'Сохранение...');
                let saveObj = [];
                for (let g of vm.groups) {
                    saveObj.push(Object.assign({}, g, {
                        //ProjectId: vm.$route.params.projectId
                    }))
                }

                backendApi.skuGroupsSave(vm.projectId, saveObj).then(function (response) {
                    UI.unblockUI('.portlet');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении групп');
                    } else {
                        UI.toastr.success('Успешно сохранено');
                        vm.reload();
                    }
                });
            },

            onGroupEditCancel(group) {
                group.Edited = false;
                group.Name = group.OriginName;
            },


            onSkuSettingsDrop(dropResult) {
                let vm = this;

                if (dropResult.removedIndex === dropResult.addedIndex) {
                    return;
                }

                let rolesTemp = _.orderBy(Object.values(vm.skuSettings), 'SettingsOrder');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                rolesTemp.forEach((role) => {
                    role.SettingsOrder = order++;

                    vm.skuSettings[role.FieldName].SettingsOrder = role.SettingsOrder;
                });
            },

            onAddNewSettings() {
                let vm = this;
                let fields = Object.values(vm.skuSettings).filter(x => x.Edited);
                if (fields.length > 0) {
                    for (let i = 0; i < fields.length; i++) {
                        let qnt = Object.values(vm.skuSettings).filter(x => !x.Edited && x.Title === fields[i].Title).length;
                        if (qnt > 0) {
                            UI.toastr.error('Укажите другое название поля. Поле [' + fields[i].Title + '] уже используется');
                            return;
                        }
                    }
                }

                let maxOrder = 1;
                let customFieldName;
                let title;
                for (let prop in this.skuSettings) {
                    let s = this.skuSettings[prop];
                    if (s.SettingsOrder > maxOrder) {
                        maxOrder = s.SettingsOrder;
                    }
                    s.Edited = false;
                }
                let arrNames = Object.values(this.skuSettings).map(x => x.FieldName);
                let arrTitles = Object.values(this.skuSettings).map(x => x.Title);
                for (let i = 1; i <= 50; i++) {
                    if(!arrNames.some(x => x === 'CustomField' + i)){
                        customFieldName = 'CustomField' + i;
                        break;
                    }
                }
                if (!arrTitles.some(x => x === 'Новое поле')) {
                    title = 'Новое поле';
                } else {
                    for (let i = 1; i <= 50; i++) {
                        if (!arrTitles.some(x => x === 'Новое поле' + i)) {
                            title = 'Новое поле' + i;
                            break;
                        }
                    }
                }
                if (customFieldName) {
                    this.$set(this.skuSettings, customFieldName, {
                        FieldName: customFieldName,
                        Title: title,
                        SettingsOrder: ++maxOrder,
                        Edited: true,
                        Selected: true,
                        ShowInList: false,
                        ShowInDetails: false
                    })
                }
            },

            onSettingsOkBtn(skuSettingsItem) {
                let qnt = Object.values(this.skuSettings).filter(x => !x.Edited && x.Title === skuSettingsItem.Title).length;
                if (qnt > 0) {
                    UI.toastr.error('Укажите другое название поля. Поле [' + skuSettingsItem.Title + '] уже используется');
                } else {
                    skuSettingsItem.Edited = false;
                }
            },

            onSettingsEditBtn(skuSettingsItem){
                for (let prop in this.skuSettings) {
                    this.$set(this.skuSettings[prop], 'Edited', false);
                }
                skuSettingsItem.Edited = true;
            },

            onSettingsRemoveBtn(skuSettingsItem){
                this.$delete(this.skuSettings, skuSettingsItem.FieldName);
            },

            saveFilterState() {
                let stateObj = {
                    projectId: this.projectId,
                    search: this.search,
                    active: this.active,
                    folderId: this.$route.query.folderId,
                    page: this.page,
                    scrollTop: this.scrollTop
                };
                sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
                //console.info('saveFilterState -> stateObj:', stateObj);
            },

            recoverFilterState() {
                let stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
                //console.info('recoverFilterState -> stateObj:', stateObj);
                if (stateObj) {
                    if ((stateObj.folderId == null || stateObj.folderId == this.$route.query.folderId) && (stateObj.projectId == this.projectId)) {
                        if (stateObj.search) {
                            this.search = stateObj.search;
                        }
                        this.active = stateObj.active;
                        if (stateObj.page) {
                            this.page = stateObj.page;
                        }
                        if (stateObj.scrollTop) {
                            this.scrollTop = stateObj.scrollTop;
                        }
                    }
                    else {
                        console.info(`recoverFilterState -> wrong folderId (stateObj.folderId = ${stateObj.folderId}) or projectId (${stateObj.projectId})`);
                    }
                    this.clearFilterState();
                }
            },

            clearFilterState() {
                sessionStorage.removeItem(cacheKey);
            }
        },

        mounted() {
            let vm = this;

            vm.recoverFilterState();

            Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
                vm.loadNext();
            });

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {
                    let elem = $(this);
                    let scrollTop = elem.scrollTop();
                    vm.scrollTop = scrollTop;

                    if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                        //console.info('elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight()', [elem[0].scrollHeight] - elem.scrollTop(), elem.outerHeight());
                        if (elem[0].scrollHeight - scrollTop - 700 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });
            });
        },

        destroyed() {
            $('.body-panel-content').off('scroll');
        }
    }
</script>

<style scoped>
    .panel-block-news h2{
        letter-spacing: initial;
    }
    #tSkuFieldSett tr.smooth-dnd-draggable-wrapper{
        display: table-row;
    }
    #tSkuFieldSett .smooth-dnd-ghost{
        display: table-row !important;
    }
    #tSkuFieldSett .smooth-dnd-ghost > td:first-child{
        width: 100%;
    }
    .result-import {letter-spacing: 0;background: #fff;}
    .panel-body-actions-false{border-top: none;height:62px}
    .panel-body-actions-footer{position:absolute;bottom:0px;width:100%;}
</style>


// WEBPACK FOOTER //
// Content/src/views/Sku.vue